module.exports = __webpack_public_path__ + "assets/img/nobody.6791cfb2.png";